import { Planner }   from "../../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import {
  PLANNER_SHOW_SCHEDULE_TT,
  PLANNER_HIDE_SCHEDULE_TT
} from 'apps/events';
class Detail extends Planner {
  indexStyle: string; //css for index label
  ttData: any;
  init(){
    super.init();
    this.ttData = { phaseData: { identity: '' } }
    document.addEventListener(PLANNER_SHOW_SCHEDULE_TT, (e) => this.showTooltip(e));
  }
  showTooltip(e){
    this.ttData = e.detail.planner_tooltip_detail;
    this.indexStyle = 'border-color: ' + this.ttData.phaseData.colorcode;
    this.indexStyle += '; color: ' + this.ttData.phaseData.colorcode;
    this.update();
  }
}
riot.mixin('orders.planner.tooltip.detail', Detail as riot.TagMixin)
